// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__GxTl-","checked":"switch_checked__JQDXA"};